import { createContext, useContext } from 'react';
import type { IMiniDifferential } from 'src/interviews/components/TreatmentPlan/variants/Default/Body/View';

import type {
  IDiagnosis,
  IInterviewResults,
  ITreatmentPlan,
  TreatmentSupplier,
} from 'src/packages/polaris/types';

type RelatedReading = {
  categories: string[];
  overview: string;
  page_type: 'article' | 'blogPost';
  relevance: number;
  slug: string;
  title: string;
  url: string;
};

type RichEndingResult = {
  differential?: IDiagnosis | IMiniDifferential;
  interviewResult?: IInterviewResults;
  relatedReadings?: RelatedReading[];
  treatmentPlan?: ITreatmentPlan;
  treatmentSuppliers?: TreatmentSupplier[];
};

type RichEndingContextType = RichEndingResult & {
  setRelatedReadings: (readings: RelatedReading[]) => void;
  setTreatmentPlan: (treatmentPlan: ITreatmentPlan) => void;
  setTreatmentSuppliers: (treatmentSuppliers: TreatmentSupplier[]) => void;
};

const RichEndingContext = createContext<RichEndingContextType>({
  setRelatedReadings: () => {},
  setTreatmentPlan: () => {},
  setTreatmentSuppliers: () => {},
});

function useRichEndingContext() {
  return useContext(RichEndingContext);
}

export { RichEndingContext };
export default useRichEndingContext;
export type { RichEndingResult };
